import { attr } from '@ember-data/model';
import BaseModel, { type IResourceName } from 'volta/models/base-model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Translations } from 'ember-intl/-private/utils/translations';

export const TranslationResourceName: IResourceName = {
  singular: 'translation',
  plural: 'translations'
};

export default class Translation extends BaseModel {
  @attr('string') declare locale: string;
  @attr({ defaultValue: () => [] }) messages!: Translations;

  [Type] = 'translation' as const;
}
